import { render } from "./FactorDetail.vue?vue&type=template&id=ae09fd26"
import script from "./FactorDetail.vue?vue&type=script&lang=js"
export * from "./FactorDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__